import * as React from "react";
import Header from "./Header";
import ReferralService from "../services/ReferralService";
import Loading from "./Loading";
import StoreContainer from "../stores/StoreContainer";
import MessengerFlexContainer from "./MessengerFlexContainer";

interface Props {
  isPopout: boolean;
}

interface State {
  bootstrapped: boolean;
  referral: {
    Html: string;
    ExternalUrl: string;
  };
}

class Referral extends React.Component<Props, State> {
  state = {
    bootstrapped: false,
    referral: {
      Html: "",
      ExternalUrl: ""
    }
  };

  componentWillMount() {
    this.loadReferral();
  }

  loadReferral() {
    var referralPromise = ReferralService.getReferral();
    referralPromise.then(referral => {
      this.setState({
        referral,
        bootstrapped: true
      });
    });
  }

  renderIframe() {
    if (!this.state.bootstrapped) {
      return <Loading />;
    }

    if (this.state.referral.ExternalUrl) {
      return (
        <iframe
          style={{
            width: "100%",
            minHeight: "-webkit-fill-available",
            border: "none"
          }}
          src={this.state.referral.ExternalUrl}
        />
      );
    }

    return (
      <div
        style={{
          width: "100%",
          minHeight: "-webkit-fill-available"
        }}
        className="velaro-referral-container"
        dangerouslySetInnerHTML={{ __html: this.state.referral.Html }}
      />
    );
  }

  render() {
    return (
      <MessengerFlexContainer>
        <Header
          isPopout={this.props.isPopout}
          onCollapse={() => StoreContainer.FrameStore.collapseOrClose()}
        />
        {this.renderIframe()}
      </MessengerFlexContainer>
    );
  }
}

export default Referral;
